import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Apiservice from "../Apiservice";
import StaffProfile from "./StaffProfile"; // ✅ already created

const PWMProgression = () => {
  const [roles, setRoles] = useState([]);
  const [pwmStaffs, setPwmStaffs] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      let response = await Apiservice.Pwm();
      if (response.success && response.data) {
        setPwmStaffs(response.data.pwm || []);
        setRoles(response.data.roles || []);
      } else {
        alert(response.message || "No data found");
      }
    };
    fetchData();
  }, []);

  const openProfileModal = (userId) => {
    setSelectedUserId(userId);
    setShowModal(true);
  };

  return (
    <div className="container-fluid py-4">
      {/* Title */}
      <div className="row mb-4">
        <div className="col text-center">
          <h3 className="fw-bold text-primary">PWM Progression Officers</h3>
          <p className="text-muted">Track officers and their role progression timeline</p>
        </div>
      </div>

      <div className="row">
        {/* Roles Section */}
        <div className="col-md-4 mb-4">
          <div className="card shadow-sm border-0 h-100">
            <div className="card-header bg-primary text-white fw-bold">
              Role Hierarchy
            </div>
            <div className="card-body">
              <ul className="list-group list-group-flush">
                {roles.map((role) => (
                  <li key={role.id} className="list-group-item d-flex justify-content-between align-items-center">
                    <div>
                      <span className="fw-semibold">{role.name}</span>
                      <small className="d-block text-muted">Rank: {role.rank}</small>
                    </div>
                    {role.promotionDurationMonths && (
                      <span className="badge bg-info rounded-pill">
                        {role.promotionDurationMonths} mo
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Progression Section */}
        <div className="col-md-8 mb-4">
          <div className="card shadow-sm border-0 h-100">
            <div className="card-header bg-success text-white fw-bold">
              Eligible for Promotion
            </div>
            <div className="card-body">
              {pwmStaffs.length > 0 ? (
                pwmStaffs.map((progression) => (
                  <div key={progression.role_id} className="mb-4 border-bottom pb-3">
                    <h6 className="fw-bold text-secondary">
                      {progression.current_role}{" "}
                      <i className="bi bi-arrow-right text-dark mx-2"></i>{" "}
                      {progression.next_role}
                    </h6>

                    <div className="table-responsive">
                      <table className="table table-sm table-striped align-middle">
                        <thead className="table-light">
                          <tr>
                            <th style={{ width: "5%" }}>#</th>
                            <th>Name</th>
                            <th>Date of Join</th>
                          </tr>
                        </thead>
                        <tbody>
                          {progression.users.map((user, index) => (
                            <tr key={user.id}>
                              <td>{index + 1}</td>
                              <td
                                className="text-primary fw-semibold"
                                style={{ cursor: "pointer" }}
                                onClick={() => openProfileModal(user.id)}
                              >
                                {user.name}
                              </td>
                              <td>
                                {new Date(user.dateOfJoin).toLocaleDateString("en-IN", {
                                  year: "numeric",
                                  month: "short",
                                  day: "numeric",
                                })}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-muted text-center">No officers eligible for progression yet.</p>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Staff Profile */}
      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content shadow-lg">
              <div className="modal-header">
                <h5 className="modal-title">Staff Profile</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                <StaffProfile userId={selectedUserId} />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PWMProgression;
